import { useMemo } from 'react';
import useGeneralSettingsStore from '../../../stores/GeneralSettings/useGeneralSettingsStore';
import { CustomerStatusType } from '../../customer/types/customerStatusType';
import { getAllowedCustomerStatusToCreateOrder } from '../../customer/utils/customerStatus.utils';

const useCustomerStatusToCreateOrder = (): CustomerStatusType[] => {
  const { generalSettings } = useGeneralSettingsStore();

  const allowedCustomerStatusToCreateOrder = useMemo(() => {
    return getAllowedCustomerStatusToCreateOrder({
      allowBlockedCustomerToCreateOrder: generalSettings?.allowBlockedCustomerToCreateOrder,
    });
  }, [generalSettings]);

  return allowedCustomerStatusToCreateOrder;
};

export default useCustomerStatusToCreateOrder;
